module.exports = __webpack_public_path__ + "img/no-order.cd573368.png";